
import { Component, Vue } from 'vue-property-decorator';

import ExpandIcon from "@/components/utils/ExpandIcon.vue";
import { GetInstructionFile } from '@/components/utils/GetInstructionFile';

@Component({
    components:{
        ExpandIcon
    }
})
export default class BookOfAuthoritiesRspToAppealPg extends Vue {

    showBookOfAuthoritiesInfo = true;
    showPointsInfo = false;

    public showBookOfAuthorities(show: boolean){        
        if (show) {
            this.showBookOfAuthoritiesInfo = true;
            this.$emit('adjustHeights', 0, '26rem')
        } else {
            this.showBookOfAuthoritiesInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showPoints(show: boolean){        
        if (show) {
            this.showPointsInfo = true;
            this.$emit('adjustHeights', 1, '35rem')
        } else {
            this.showPointsInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }
    
    public downloadInstructions(pdf_name){
        GetInstructionFile(pdf_name);        
    }

}
